// extracted by extract-css-chunks-webpack-plugin
module.exports = {"toast":"app-components-usersong-warningbox--toast"};